import { render } from "./KsMy.vue?vue&type=template&id=74486ed0&scoped=true"
import script from "./KsMy.vue?vue&type=script&lang=js"
export * from "./KsMy.vue?vue&type=script&lang=js"

import "./KsMy.vue?vue&type=style&index=0&id=74486ed0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74486ed0"]])

export default __exports__